module.exports = __webpack_public_path__ + "img/logo.38000f0c.png";